import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const BorrowerRegistration = lazy(() => import('../../container/borrower/borrower/BorrowerRegistration'));
const BorrowerList = lazy(() => import('../../container/borrower/borrower/borrowerList'));
const BorrowerUpdate = lazy(() => import('../../container/borrower/borrower/borrowerUpdate'));
const BorrowerDetails = lazy(() => import('../../container/borrower/borrower/borrowerDetail/borrowerDetails'));

function OwnerRoute() {
  return (
    <Routes>
      <Route path="registration" element={<BorrowerRegistration />} />
      <Route path="list" element={<BorrowerList />} />
      <Route path="update/:id" element={<BorrowerUpdate />} />
      <Route path="detail/:id" element={<BorrowerDetails />} />
    </Routes>
  );
}

export default OwnerRoute;
